var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNzlFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0h60v45H0V0Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v22.5H0V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.516 0 11.437 8.484L26.343 0H30v2.906l-11.25 8.39L30 19.642V22.5h-3.75L15 14.11 3.797 22.5H0v-2.813l11.203-8.343L0 3V0h3.516Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.875 13.172 30 20.625V22.5l-12.703-9.328h2.578Zm-8.625.937.281 1.641-9 6.75H0l11.25-8.39ZM30 0v.14L18.328 8.954l.094-2.062L27.656 0H30ZM0 0l11.203 8.25H8.391L0 1.969V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.297 0v22.5h7.5V0h-7.5ZM0 7.5V15h30V7.5H0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.047v4.5h30v-4.5H0ZM12.797 0v22.5h4.5V0h-4.5Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNzlFlag);
export default __webpack_public_path__ + "static/media/nzl-flag.5511bdf38a9f6d699cf034557df13097.svg";
export { ForwardRef as ReactComponent };